import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchAllPages, fetchAllGalleries } from '../lib/cms';

const CMSContext = createContext(null);

export function CMSProvider({ children }) {
  const [pages, setPages] = useState([]);
  const [galleries, setGalleries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function loadCMSData() {
      try {
        setLoading(true);
        const [fetchedPages, fetchedGalleries] = await Promise.all([
          fetchAllPages(),
          fetchAllGalleries()
        ]);
        setPages(fetchedPages);
        setGalleries(fetchedGalleries);
      } catch (err) {
        console.error('Fejl ved indlæsning af CMS-data:', err);
        setError('Kunne ikke hente indhold fra CMS. Prøv venligst at genindlæse siden.');
      } finally {
        setLoading(false);
      }
    }

    loadCMSData();
  }, []);

  const getPage = (slug) => {
    return pages.find(p => p.page_slug === slug) || null;
  };

  const getGallery = (slug) => {
    return galleries.find(g => g.gallery_slug === slug) || null;
  };

  return (
    <CMSContext.Provider value={{ pages, galleries, loading, error, getPage, getGallery }}>
      {children}
    </CMSContext.Provider>
  );
}

export function useCMS() {
  const context = useContext(CMSContext);
  if (!context) {
    throw new Error('useCMS skal bruges inden for en CMSProvider');
  }
  return context;
}
